export default __webpack_public_path__ + "static/media/english-to-german-logo.5e0903d1.png";